import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPin, Users, ChevronRight } from 'lucide-react';
import { useVenues } from '@/hooks/useApi';

export default function VenuesPage() {
  const { t, i18n } = useTranslation();
  const { data: venues, isLoading } = useVenues();

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <h1 className="section-title">{t('venues.title')}</h1>
      <p className="section-subtitle">{t('venues.subtitle')}</p>

      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="card animate-pulse">
              <div className="h-48 bg-bg-secondary rounded mb-4" />
              <div className="h-6 bg-bg-secondary rounded w-2/3 mb-3" />
              <div className="h-4 bg-bg-secondary rounded w-full" />
            </div>
          ))}
        </div>
      ) : Array.isArray(venues) && venues.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {venues.map((venue) => (
            <Link key={venue.id} to={`/venues/${venue.id}`} className="card group overflow-hidden">
              {venue.imageUrl && (
                <div className="w-full h-48 -mt-6 -mx-6 mb-4" style={{ width: 'calc(100% + 3rem)' }}>
                  <img
                    src={venue.imageUrl}
                    alt={venue.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                  />
                </div>
              )}
              <h3 className="font-bold text-xl mb-2 group-hover:text-primary transition-colors">
                {i18n.language === 'en' ? venue.nameEn : venue.name}
              </h3>
              <div className="flex items-center gap-4 text-sm text-text-secondary mb-3">
                <span className="flex items-center gap-1">
                  <MapPin className="w-4 h-4" /> {venue.address}
                </span>
                <span className="flex items-center gap-1">
                  <Users className="w-4 h-4" /> {t('venues.capacity')}: {venue.capacity}
                </span>
              </div>
              <p className="text-text-secondary text-sm line-clamp-2">{venue.description}</p>
              <div className="mt-4 flex items-center text-primary text-sm font-medium group-hover:gap-2 transition-all">
                {t('common.viewDetails')} <ChevronRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="text-center py-20 text-text-secondary">{t('common.noData')}</div>
      )}
    </div>
  );
}
